export default __webpack_public_path__ + "static/media/gaming_Footer_Habanero_Supplier.68672c35.svg";